import LegalPage from '@/components/marketing/LegalPage';

export default function CookiesPage() {
  return (
    <LegalPage title="Cookie Notice" lastUpdated="February 2026" testId="cookies-page">
      <p className="text-base text-slate-200">
        This Cookie Notice explains how PROP VEIW uses cookies and similar technologies on our
        website and within the Service.
      </p>

      <h2>1. What Are Cookies?</h2>
      <p>
        Cookies are small text files stored on your device when you visit a website. They allow
        the website to recognize your device and remember information about your visit. Similar
        technologies (such as local storage and pixel tags) function in comparable ways.
      </p>

      <h2>2. Categories of Cookies We Use</h2>

      <h3>Strictly necessary</h3>
      <p>
        These cookies are required for the Service to function. They include our session cookie
        ("<code>access_token</code>") which keeps you logged in, and CSRF tokens that protect
        against cross-site request forgery. You cannot disable these without breaking the Service.
      </p>

      <h3>Functional</h3>
      <p>
        Used to remember preferences such as your active property selector, view mode (month vs.
        week), and timezone. Disabling these will not break the Service but will reset your
        preferences on every visit.
      </p>

      <h3>Analytics</h3>
      <p>
        We use first-party analytics to understand which features are most useful and where users
        encounter friction. We do not share analytics data with advertisers. You may opt out from
        the cookie banner.
      </p>

      <h3>Marketing</h3>
      <p>
        We currently do not run third-party advertising cookies on the marketing site. If that
        changes, we will update this notice and request your consent before any non-essential
        cookies are set.
      </p>

      <h2>3. Managing Your Preferences</h2>
      <p>
        You can clear or block cookies through your browser settings. Most browsers also allow
        you to set "Do Not Track" preferences, which we honor where technically feasible. When we
        offer a cookie banner, you can re-open it at any time from the footer link or by
        emailing <a href="mailto:privacy@propveiw.com">privacy@propveiw.com</a>.
      </p>

      <h2>4. Third-Party Cookies in the App</h2>
      <p>
        When you connect external services (Airbnb iCal, VRBO, Google calendar sync, etc.), those
        services may set cookies on their own domains. Those cookies are governed by the third
        party's privacy and cookie policies.
      </p>

      <h2>5. Updates to This Notice</h2>
      <p>
        We may update this Cookie Notice from time to time. Material changes will be flagged on
        the website or in-app.
      </p>

      <h2>6. Contact</h2>
      <p>
        Questions about cookies? Email{' '}
        <a href="mailto:privacy@propveiw.com">privacy@propveiw.com</a>.
      </p>
    </LegalPage>
  );
}
